import React, { ReactNode } from 'react'
import { CustomButton, Modal, ModalContent, ModalFooter, ModalTitle, ModalWrapper } from './styles'
import { Icon } from '@dasa-health/alma-react'

type CustomModalProps = {
    showCloseButton?: boolean
    onClose?: () => void
    open?: boolean
    title?: string
    children?: ReactNode
    buttonData: {
        label: string
        href: string
        icon?: React.ReactElement
        taget?: string
    }
    currentService: () => void
}

export const CustomModalDuvidas = ({
    onClose,
    open,
    title,
    showCloseButton = true,
    children,
    buttonData,
    currentService,
}: CustomModalProps) => (
    <Modal data-testid="close-button" fullMobile={true} onClose={onClose} open={open}>
        <ModalWrapper>
            {title && <ModalTitle>{title}</ModalTitle>}
            {children && <ModalContent>{children}</ModalContent>}
            {showCloseButton && (
                <ModalFooter>
                    <CustomButton
                        data-current-service={currentService()}
                        data-item-position="Modal Dúvidas Central de Atendimento"
                        data-item-text={buttonData.label}
                        href={buttonData?.href}
                        target={buttonData?.taget}
                        title={buttonData.label}
                        type="button"
                    >
                        {buttonData?.icon && <Icon size="lg">{buttonData?.icon}</Icon>}
                        {buttonData?.label}
                    </CustomButton>
                </ModalFooter>
            )}
        </ModalWrapper>
    </Modal>
)
